import React from 'react';
import NewResultTable from '../NewResultTable';
import NewResultError from '../NewResultError';

const NewResultContent = ({ gameType }) => {
  return (
    <>
      <div className="py-[50px] ltg:py-[105px] h-screen lg:h-fit">
        {/* <NewResultError /> */}
        <NewResultTable gameType={gameType} />
      </div>
    </>
  );
};

export default NewResultContent;
